import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container, Box, TextField, Button, Typography,
    Paper, Alert
} from '@mui/material';
import { useThemeContext } from '../contexts/ThemeContext';
import api from '../services/api';

function Login() {
    const navigate = useNavigate();
    const { themeMode, colors } = useThemeContext();
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [error, setError] = useState('');

    // Redireciona se já estiver logado
    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            console.log('Usuário já autenticado, redirecionando para /');
            navigate('/');
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        console.log('Tentando fazer login com:', formData);
        
        try {
            const response = await api.post('/auth/login', formData);
            console.log('Resposta do backend:', response.data);
            localStorage.setItem('token', response.data.token);
            console.log('Token salvo no localStorage');
            console.log('Redirecionando para /');
            navigate('/');
        } catch (err) {
            console.error('Erro no login:', err);
            
            // Se for bloqueio por horário, redireciona para tela de bloqueio
            if (err.response?.data?.motivo === 'horario_bloqueado') {
                navigate('/bloqueio', {
                    state: {
                        motivo: 'horario_bloqueado',
                        hora_inicio: err.response.data.hora_inicio,
                        hora_fim: err.response.data.hora_fim,
                        hora_atual: err.response.data.hora_atual,
                        limparToken: false
                    }
                });
                return;
            }
            
            setError(err.response?.data?.error || 'Erro ao fazer login');
        }
    };

    // Estilos do fundo com logo baseado no tema
    const getBackgroundStyle = () => {
        const logoPath = '/Logo-Soubhia.jpg';
        const baseStyle = {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
        };

        if (themeMode === 'dark') {
            return {
                ...baseStyle,
                backgroundImage: `linear-gradient(rgba(62, 39, 35, 0.85), rgba(62, 39, 35, 0.85)), url(${logoPath})`,
                backgroundColor: colors.darkBrown,
            };
        } else if (themeMode === 'medium') {
            return {
                ...baseStyle,
                backgroundImage: `linear-gradient(rgba(232, 232, 232, 0.9), rgba(232, 232, 232, 0.9)), url(${logoPath})`,
                backgroundColor: '#E8E8E8',
            };
        } else {
            return {
                ...baseStyle,
                backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)), url(${logoPath})`,
                backgroundColor: colors.white,
            };
        }
    };

    return (
        <Box sx={getBackgroundStyle()}>
            <Container component="main" maxWidth="xs">
                <Paper 
                    sx={{ 
                        p: 4,
                        backgroundColor: themeMode === 'dark' 
                            ? 'rgba(93, 64, 55, 0.95)' 
                            : themeMode === 'medium'
                            ? 'rgba(255, 255, 255, 0.98)'
                            : 'rgba(255, 255, 255, 0.98)',
                        boxShadow: themeMode === 'dark' 
                            ? '0 8px 32px rgba(0, 0, 0, 0.5)'
                            : '0 8px 32px rgba(0, 0, 0, 0.15)',
                    }}
                >
                    <Typography 
                        component="h1" 
                        variant="h5" 
                        align="center" 
                        gutterBottom
                        sx={{
                            fontWeight: 600,
                            color: themeMode === 'dark' ? colors.gold : colors.darkBrown,
                            mb: 3
                        }}
                    >
                        ADVOCACIA SOUBHIA
                    </Typography>
                    
                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <Box component="form" onSubmit={handleSubmit}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Usuário"
                            name="username"
                            autoComplete="username"
                            autoFocus
                            value={formData.username}
                            onChange={(e) => setFormData({
                                ...formData,
                                username: e.target.value
                            })}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Senha"
                            type="password"
                            autoComplete="current-password"
                            value={formData.password}
                            onChange={(e) => setFormData({
                                ...formData,
                                password: e.target.value
                            })}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Entrar
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
}

export default Login; 